export default __webpack_public_path__ + "static/media/WallNotification_Wetumpka-Picture.e01b1682.png";